// @ts-nocheck
/*
 * Port of views/dashboard/numbers/_form_update.js (377 lines).
 * BYTE-IDENTICAL — includes number status dropdown (not in create form),
 * cost lock when Free category, currency locked to derived country
 * currency, includeDidId query on VMN/TOLL FREE fetch, duplicate country
 * useEffect at lines 51-68 + 103-122 preserved verbatim.
 */
import React, { useState, useEffect } from 'react';
/* Local micro-shim for react-bootstrap Form.* — see NumberForm.tsx for the
 * identical block. */
const _cx = (...args: any[]) => args.filter(Boolean).join(' ');
const Form: any = ({ children, onSubmit, className, ...props }: any) => (
  <form
    className={className}
    onSubmit={onSubmit || ((e: any) => e.preventDefault())}
    {...props}
  >
    {children}
  </form>
);
Form.Group = ({ className, controlId: _c, children, ...props }: any) => (
  <div className={_cx('mb-3', className)} {...props}>{children}</div>
);
Form.Label = ({ className, children, htmlFor, ...props }: any) => (
  <label className={_cx('form-label', className)} htmlFor={htmlFor} {...props}>{children}</label>
);
Form.Control = ({ as, className, children, isInvalid, ...props }: any) => {
  const cls = _cx('form-control', isInvalid && 'is-invalid', className);
  if (as === 'select') return <select className={cls} {...props}>{children}</select>;
  if (as === 'textarea') return <textarea className={cls} {...props} />;
  return <input className={cls} {...props} />;
};
Form.Select = ({ className, children, ...props }: any) => (
  <select className={_cx('form-control form-select', className)} {...props}>{children}</select>
);
Form.Check = ({ type = 'checkbox', label, id, className, inline, children, ...props }: any) => (
  <div className={_cx('form-check', inline && 'form-check-inline', className)}>
    <input type={type} id={id} className="form-check-input" {...props} />
    {label !== undefined && <label htmlFor={id} className="form-check-label">{label}</label>}
    {children}
  </div>
);
Form.Text = ({ muted, className, children, ...props }: any) => (
  <small className={_cx('form-text', muted && 'text-muted', className)} {...props}>{children}</small>
);
import {
  API_COUNTRY_CODES_LIST,
  API_NUMBER_STATUS,
  API_OPERATORS_LIST,
  API_STATES_LIST,
  API_TRUNKS_LIST,
  API_AVAILABLE_DID_NUMBERS,
} from '@/service/url';
import { getApiCall, postApiCall } from '@/service/httpCall';
import { NUMBERS_TYPES, NUMBER_ROUTING_TYPE } from '@/utilities/constant';


const getTrunkAllowedCountries = (trunk) => {
  if (!trunk) return [];
  const mapped = (trunk.country_codes || []).map((c) => String(c).toUpperCase());
  if (mapped.length) return mapped;
  return Number(trunk.is_international) === 1 ? [] : ['IN'];
};

export default function RenderNumberForm(props) {
  const [countryCodesList, setCountryCodesList] = useState([]);
  const [numberStatusList, setNumberStatusList] = useState([]);
  const [stateCodeList, setStateCode] = useState([]);
  const isIndia = props.countryCodeId === 'IN';
  const [operatorsList, setOperatorsList] = useState([]);
  const [trunksList, setTrunksList] = useState([]);
  const [availableDidList, setAvailableDidList] = useState([]);
  const currencySymbol = isIndia ? '₹' : '$';

  useEffect(() => {
    if (props.numberType === 'VMN' || props.numberType === 'TOLL FREE') {
      const url = props.linkedDidId
        ? `${API_AVAILABLE_DID_NUMBERS}?includeDidId=${props.linkedDidId}`
        : API_AVAILABLE_DID_NUMBERS;
      getApiCall(url, {})
        .then((resp) => setAvailableDidList(Array.isArray(resp) ? resp : []))
        .catch((err) => {
          console.log(err);
          setAvailableDidList([]);
        });
    } else {
      setAvailableDidList([]);
    }
  }, [props.numberType, props.linkedDidId]);

  useEffect(() => {
    getApiCall(API_COUNTRY_CODES_LIST, {}).then(onCountryCodesListSuccess).catch(onError);
    getApiCall(API_NUMBER_STATUS, {}).then(onNumberStatusSuccess).catch(onError);
    getApiCall(API_OPERATORS_LIST, {}).then(onOperatorListSuccess).catch(onError);
    getApiCall(API_TRUNKS_LIST, {}).then(onTrunksListSuccess).catch(onError);
  }, []);

  function onOperatorListSuccess(resp) {
    setOperatorsList(resp);
  }

  function onTrunksListSuccess(resp) {
    setTrunksList(resp);
  }

  useEffect(() => {
    if (props.countryCodeId) {
      const params = { countryCode: props.countryCodeId };
      postApiCall(API_STATES_LIST, params)
        .then((response) => setStateCode(response))
        .catch((error) => console.error('Error while fetching states:', error));
    }
  }, [props.countryCodeId]);

  function onNumberStatusSuccess(resp) {
    setNumberStatusList(resp);
  }

  function onCountryCodesListSuccess(resp) {
    setCountryCodesList(resp);
  }

  function onError(err) {
    console.log(err);
  }

  useEffect(() => {
    if (props.countryCodeId) {
      const params = { countryCode: props.countryCodeId };
      postApiCall(API_STATES_LIST, params)
        .then((response) => setStateCode(response))
        .catch((error) => console.error('Error while fetching states:', error));

      if (props.countryCodeId === 'IN') {
        props.setCurrency('INR');
      } else if (props.countryCodeId) {
        props.setCurrency('USD');
      }
    }
  }, [props.countryCodeId]);

  useEffect(() => {
    if (props.category === 'Free') {
      props.setCost(0);
    }
  }, [props.category]);


  const selectedTrunk = trunksList.find((t) => String(t.id) === String(props.trunks));
  const trunkCountryCodes = getTrunkAllowedCountries(selectedTrunk);

  const countryOptions =
    props.numberType === 'DID' && trunkCountryCodes.length
      ? countryCodesList.filter((c) => trunkCountryCodes.includes(String(c.code).toUpperCase()))
      : countryCodesList;


  const operatorOptions =
    props.numberType === 'DID' && selectedTrunk
      ? operatorsList.filter((o) => Number(o.is_international) === Number(selectedTrunk.is_international))
      : operatorsList;

  function handleTrunkChange(trunkId) {
    props.setTrunks(trunkId);
    if (!trunkId) return;

    const trunk = trunksList.find((t) => String(t.id) === String(trunkId));

    const trunkType = Number(trunk?.is_international) === 1 ? 1 : 0;
    const currentOperator = operatorsList.find(
      (o) => String(o.name).toLowerCase() === String(props.operator || '').toLowerCase(),
    );
    if (currentOperator && Number(currentOperator.is_international) !== trunkType) {
      props.setOperator('');
    }

    const codes = getTrunkAllowedCountries(trunk);
    if (codes.length === 0) return;

    const current = String(props.countryCodeId || '').toUpperCase();
    if (codes.includes(current)) return;

    if (props.setStateCode) props.setStateCode('');
    if (codes.length === 1) {
      props.setCountryCodeId(codes[0]);
    } else {
      props.setCountryCodeId('');
    }
  }

  const countryCallingCode = String(
    countryCodesList.find((country) => country.code === props.countryCodeId)?.calling_code || ''
  )
    .trim()
    .replace(/^\+/, '');

  return (
    <>
      <div className="row g-4">
        <Form.Group className="col-md-4 form-group mb-1">
          <Form.Label htmlFor="numberRouteType">
            Number Routing: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
          </Form.Label>
          <Form.Select
            id="numberRouteType"
            value={props.numberRoutingType}
            className="p-2"
            onChange={(e) => props.setNumberRoutingType(e.target.value)}
            required
          >
            <option value="">Select Number Routing</option>
            {NUMBER_ROUTING_TYPE.map((numberRouting, idx) => (
              <option key={idx} value={numberRouting.value}>
                {numberRouting.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-4 form-group mb-1">
          <Form.Label htmlFor="number_type">
            Number Type: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
          </Form.Label>
          <Form.Select
            id="numberType"
            value={props.numberType}
            className="p-2"
            onChange={(e) => props.setNumberType(e.target.value)}
            required
          >
            <option value={''}>Select Number Type</option>
            {NUMBERS_TYPES.map(function (val, idx) {
              return (
                <option key={idx} value={val.value}>
                  {val.label}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-4 form-group mb-1">
          <Form.Label htmlFor="currency">
            Currency: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
          </Form.Label>
          <Form.Select
            id="currency"
            value={props.currency}
            className="p-2"
            onChange={(e) => props.setCurrency(e.target.value)}
            disabled={props.countryCodeId ? true : false}
            style={props.countryCodeId ? { cursor: 'not-allowed', backgroundColor: '#e9ecef' } : {}}
            required
          >
            <option value="">Select Currency</option>
            <option value="INR">INR</option>
            <option value="USD">USD</option>
          </Form.Select>
        </Form.Group>

        {props.numberType === 'DID' && (
          <Form.Group className="col-md-3 form-group mb-1">
            <Form.Label htmlFor="category">
              Category: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
            </Form.Label>
            <Form.Select
              id="category"
              value={props.category}
              className="p-2"
              onChange={(e) => props.setCategory(e.target.value)}
              required
            >
              <option value="">Select Category</option>
              <option value="Free">Free</option>
              <option value="Paid">Paid</option>
            </Form.Select>
          </Form.Group>
        )}
        {props.numberType === 'DID' && (
          <Form.Group className="col-md-4 form-group mb-1">
            <Form.Label htmlFor="number_type">
              State Code: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
            </Form.Label>
            <Form.Select
              id="stateCode"
              required
              value={props.stateCode}
              className="p-2"
              onChange={(e) => props.setStateCode(e.target.value)}
            >
              <option value={''}>Select State Code</option>
              {stateCodeList &&
                stateCodeList.map(function (val, idx) {
                  return (
                    <option key={idx} value={val.isoCode}>
                      {val.name}
                      {` (${val.isoCode})`}
                    </option>
                  );
                })}
            </Form.Select>
          </Form.Group>
        )}
        <Form.Group className="col-md-2 form-group mb-1">
          <Form.Label htmlFor="country_code">
            Country Code: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
          </Form.Label>
          <Form.Select
            id="countryCodeId"
            required
            value={props.countryCodeId}
            className="p-2"
            onChange={(e) => props.setCountryCodeId(e.target.value)}
          >
            <option value={''}>Select Country Code</option>
            {countryOptions.map(function (val, idx) {
              return (
                <option key={idx} value={val.code}>
                  {val.name}
                  {` (${val.code})`}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-2 form-group mb-1">
          <Form.Label htmlFor="callingCode">Calling Code:</Form.Label>
          <Form.Control
            id="callingCode"
            type="text"
            className="p-2"
            value={countryCallingCode ? `+${countryCallingCode}` : ''}
            placeholder="Select country"
            readOnly
            disabled
            style={{ cursor: 'not-allowed', backgroundColor: '#e9ecef' }}
          />
        </Form.Group>
        <Form.Group className="col-md-3 form-group mb-1">
          <Form.Label htmlFor="did">
            DID: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="DID"
            id="did"
            value={props.DID}
            maxLength={10}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              props.setDID(value);
            }}
            required
          />
        </Form.Group>
        <Form.Group className="col-md-3 form-group mb-1">
          <Form.Label htmlFor="cost">
            Cost: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
          </Form.Label>
          <div className="input-group">
            <span className="input-group-text bg-light" style={{ cursor: 'not-allowed' }}>
              {currencySymbol}
            </span>
            <Form.Control
              type="number"
              placeholder="Cost"
              id="cost"
              value={props.cost}
              readOnly={props.category === 'Free'}
              onChange={(e) => {
                if (props.category === 'Free') return;
                const value = Number(e.target.value);
                props.setCost(value >= 0 ? value : 0);
              }}
              required
            />
          </div>
        </Form.Group>

        <Form.Group className="col-md-3 form-group mb-1">
          <Form.Label htmlFor="number_type">
            Operator: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
          </Form.Label>
          <Form.Select
            id="operator"
            placeholder="Operator"
            className="p-2"
            required
            value={props.operator.toLowerCase()}
            onChange={(e) => props.setOperator(e.target.value)}
          >
            <option value={''}>Select Operator</option>
            {operatorOptions.map(function (val, idx) {
              return (
                <option key={idx} value={val.name.toLowerCase()}>
                  {val.name}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-3 form-group mb-1">
          <Form.Label htmlFor="status">
            Status: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
          </Form.Label>
          <Form.Select
            id="numberStatusId"
            required
            value={props.status}
            className="p-2"
            onChange={(e) => props.setStatus(e.target.value)}
          >
            <option value={''}>Select Status</option>
            {numberStatusList.map(function (val, idx) {
              // Save status_code (1, 2, 3…), not `id` (10, 11, 12…) — the
              // number's `status` field is read/written as status_code
              // everywhere else (bulk-upload template, allocate dropdown).
              // Saving `id` here made "Available" (id 10) persist as the
              // same raw value as Reject's status_code (10), so the list
              // page showed "Reject" after picking "Available".
              return (
                <option key={idx} value={val.status_code}>
                  {val.status}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        {props.numberType === 'DID' && (
          <Form.Group className="col-md-3 form-group mb-1">
            <Form.Label htmlFor="status">
              Select Trunk: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
            </Form.Label>
            <Form.Select
              id="currency"
              value={props.trunks}
              className="p-2"
              onChange={(e) => handleTrunkChange(e.target.value)}
              required
            >
              <option value="">Select Trunks</option>
              {trunksList.map(function (val, idx) {
                return (
                  <option key={idx} value={val.id}>
                    {val.name}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
        )}
        {(props.numberType === 'VMN' || props.numberType === 'TOLL FREE') && (
          <Form.Group className="col-md-3 form-group mb-1">
            <Form.Label htmlFor="linkedDidId">
              DID Number: <span style={{ color: 'red', margin: '0 4px' }}>*</span>
            </Form.Label>
            <Form.Select
              id="linkedDidId"
              value={props.linkedDidId || ''}
              className="p-2"
              onChange={(e) => props.setLinkedDidId(e.target.value)}
              required
            >
              <option value="">Select DID Number</option>
              {(availableDidList || []).map(function (val, idx) {
                return (
                  <option key={idx} value={val.id}>
                    {val.actual_number}
                  </option>
                );
              })}
            </Form.Select>
            {(availableDidList || []).length === 0 && (
              <small className="text-danger">No available DID numbers found.</small>
            )}
          </Form.Group>
        )}
      </div>
      <hr />
    </>
  );
}
